import axios from 'axios';
import qs from 'qs'
import router from './router'
import {
  Message
} from 'view-design';
import jwjURL from './config'

const http = axios.create({
  baseURL: jwjURL.baseURL,
  // baseURL: '/api/',
  actionImgUrl: '',
  timeout: 500000,
});

var basic = "Basic aW5jaF93ZWI6ZGIyMThkZGUtNzllNC0xMWU4LWJhNDAtMzhjOTg2NDEyZmZj"
var loadingInstance;

// 请求拦截器
http.interceptors.request.use(config => {
  // utils.checkToken()
  var igurl = ['oauth/getWebSms', 'oauth/token', 'sys/toLogin']
  if (igurl.indexOf(config['url']) == -1) {
    checkToken()
  }

  // api 下接口跨域
  // 线上 --------------》 非线上注释掉

  config['url'] = '/display-rest/' + config['url']


  if (config['url'].indexOf('loginCode/getCode') > -1 || config['url'].indexOf('loginCode/checkIsLogin') > -1) {

    config['headers'] = {
      "Authorization": basic,
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  } else {
    var paramData = ''

    for (var key in config.data) {
      if (typeof (config.data[key]) == 'string' && config.data[key].indexOf('%') > -1) {
        config.data[key] = config.data[key].replace('/\%/gi', '%25')
      }
    }

    if (config.method == 'post') {
      if (config['url'].indexOf('news/save') > -1) {} else {
        paramData = JSON.parse(JSON.stringify(config.data))
      }
      config.data = qs.stringify(config.data, {
        indices: false
      })

    } else {
      paramData = config.data
    }
    var signData = getSign(paramData)
    for (var key in signData) {
      config['headers'][key] = signData[key]
    }

    // config['headers'] = signData
    // = Object.assign({},config['headers'],getSign(paramData))

    // config['headers']['post']   ={...signData,...config['headers']['post']}
    // config['headers']['head']   ={...signData,...config['headers']['head']}
    // config['headers']['common'] ={...signData,...config['headers']['common']}


    // config['headers']['inch-sign'] = '4F41E4C17CDEA1FDEC14E484EDFEB072'
    // config['headers']['nonce'] = '166997247100019620'
    // config['headers']['Authorization'] = 'Basic aW5jaF93ZWI6ZGIyMThkZGUtNzllNC0xMWU4LWJhNDAtMzhjOTg2NDEyZmZj'
    // config['headers']['inch-timestamp'] = '1669972471000'

  }

  // }

  return config;
}, error => {
  return Promise.reject(error);
});


// 响应拦截器
http.interceptors.response.use(res => {
  var that = this

  return res.data

  if (res.statusText == 'OK') {
    // 接口请求成功
    if (res.data.success == false) { // 请求出现错误  例如 密码不正确
      return res.data
    } else { // 数据请求正常
      return res.data
    }

  } else {

    //Message.success(res.data.msg)
    return false;
  }

}, error => {
  var that = this

  if (error && error.response) {


    if (error.response.data.code == 1001) {
      var msg = error.response.data.msg
      // if(localStorage.getItem('access_token')!=null && localStorage.getItem('access_token')!='null'){

      //     Message.error('登录过期')
      //      localStorage.setItem('access_token',null)
      // }
      // router.push('/login')


      // if(msg == '缺少token参数~'){
      //     Message.error('登录过期')
      //     router.push('/login')
      // }else{
      Message.error(msg)
      router.push('/login')
      // }


    }
    return Promise.reject(error);
  }
})

function checkToken() {
  var that = this
  var _tokenexprie = localStorage.getItem('expiresTo') || ''
  var username = localStorage.getItem('jwjcurUsername')
  var password = localStorage.getItem('jwjcurUserpwd')




  if (_tokenexprie != '') {

    if (CompareDate(_tokenexprie) < 2) {

      axios.post('oauth/token', {
        username: username,
        password: password,
        sms_code: '',
        'grant-type': 'password',
        systemid: 'web'
      }).then(back => {

        if (back && back.data && back.data['access_token']) {
          localStorage.setItem('access_token', back.data['access_token'])
          localStorage.setItem('expiresTo', back.data['expires_to'])
        }
      })
    }


  }
}

function CompareDate(d1) {
  var myDate = new Date();
  var myYear = myDate.getFullYear();
  var myMonth = myDate.getMonth();
  var myDay = myDate.getDate();
  var d2 = myYear + "-" +
    (myMonth < 9 ? ("0" + (myMonth + 1)) : (myMonth + 1)) + "-" +
    (myDay < 10 ? ("0" + myDay) : myDay);
  d2 += ' 00:00:00'

  return getDiffDay(d1, d2)

}

function getDiffDay(date_1, date_2) {
  let totalDays, diffDate
  let myDate_1 = Date.parse(date_1)
  let myDate_2 = Date.parse(date_2)
  diffDate = Math.abs(myDate_1 - myDate_2)
  totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
  return totalDays
}

function getSign(params) {


  var times = Number(Date.parse(new Date())) // 获取13位时间戳
  var random = 10000 + Math.random().toFixed(4) * 10000 // 获取五位随机数
  var timestamp = Number(String(times) + String(random)) // 拼接成18位时间戳

  var _header = {}

  var access_token = localStorage.getItem('access_token') || ''

  if (access_token) {
    _header = {
      "inch-timestamp": times,
      'access-token': access_token,
      nonce: timestamp,
    }
  } else {
    _header = {
      "inch-timestamp": times,
      nonce: timestamp,
    }
  }

  var _newStr = Object.assign(_header, params)
  _newStr = objKeySort(_newStr)
  _newStr += "&aef2890665d884a3080971b4eca594d7"
  var _sign = hex_md5(utf8(_newStr))
  _sign = _sign.toLocaleUpperCase()
  if (access_token) {
    return {
      "Authorization": basic,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      "inch-sign": _sign,
      "inch-timestamp": times,
      "access-token": access_token,
      "nonce": timestamp,
      "systemid": 'web',
      "factory": 'web',
      'grant-type': 'password',
    }
  } else {
    return {
      "Authorization": basic,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      "inch-sign": _sign,
      "inch-timestamp": times,
      "nonce": timestamp,
      "factory": 'web',
      'grant-type': 'password',
      'systemid': 'web'
    }
  }

}

function objKeySort(arys) {
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newkey = Object.keys(arys).sort();

  var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
  var str = ""
  for (var i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    // newObj[newkey[i]] = arys[newkey[i]];
    str += newkey[i] + '=' + arys[newkey[i]] + '&'
    //向新创建的对象中按照排好的顺序依次增加键值对

  }
  return str.slice(0, str.length - 1); //返回排好序的新对象
}


function utf8(inputStr) { //将中文转为UTF8
  var outputStr = "";
  for (var i = 0; i < inputStr.length; i++) {
    var temp = inputStr.charCodeAt(i);
    //0xxxxxxx
    if (temp < 128) {
      outputStr += String.fromCharCode(temp);
    }
    //110xxxxx 10xxxxxx
    else if (temp < 2048) {
      outputStr += String.fromCharCode((temp >> 6) | 192);
      outputStr += String.fromCharCode((temp & 63) | 128);
    }
    //1110xxxx 10xxxxxx 10xxxxxx
    else if (temp < 65536) {
      outputStr += String.fromCharCode((temp >> 12) | 224);
      outputStr += String.fromCharCode(((temp >> 6) & 63) | 128);
      outputStr += String.fromCharCode((temp & 63) | 128);
    }
    //11110xxx 10xxxxxx 10xxxxxx 10xxxxxx
    else {
      outputStr += String.fromCharCode((temp >> 18) | 240);
      outputStr += String.fromCharCode(((temp >> 12) & 63) | 128);
      outputStr += String.fromCharCode(((temp >> 6) & 63) | 128);
      outputStr += String.fromCharCode((temp & 63) | 128);
    }
  }
  return outputStr;
}
var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */
var chrsz = 8; /* bits per input character. 8 - ASCII; 16 - Unicode      */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s) {
  return binl2hex(core_md5(str2binl(s), s.length * chrsz));
}

function b64_md5(s) {
  return binl2b64(core_md5(str2binl(s), s.length * chrsz));
}

function str_md5(s) {
  return binl2str(core_md5(str2binl(s), s.length * chrsz));
}

function hex_hmac_md5(key, data) {
  return binl2hex(core_hmac_md5(key, data));
}

function b64_hmac_md5(key, data) {
  return binl2b64(core_hmac_md5(key, data));
}

function str_hmac_md5(key, data) {
  return binl2str(core_hmac_md5(key, data));
}

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}

function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}

function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}

function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Calculate the HMAC-MD5, of a key and some data
 */
function core_hmac_md5(key, data) {
  var bkey = str2binl(key);
  if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

  var ipad = Array(16),
    opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
  return core_md5(opad.concat(hash), 512 + 128);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
 * Convert a string to an array of little-endian words
 * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
 */
function str2binl(str) {
  var bin = Array();
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < str.length * chrsz; i += chrsz)
    bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (i % 32);
  return bin;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2str(bin) {
  var str = "";
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < bin.length * 32; i += chrsz)
    str += String.fromCharCode((bin[i >> 5] >>> (i % 32)) & mask);
  return str;
}

/*
 * Convert an array of little-endian words to a hex string.
 */
function binl2hex(binarray) {
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var str = "";
  for (var i = 0; i < binarray.length * 4; i++) {
    str += hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8 + 4)) & 0xF) +
      hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8)) & 0xF);
  }
  return str;
}

/*
 * Convert an array of little-endian words to a base-64 string
 */
function binl2b64(binarray) {
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var str = "";
  for (var i = 0; i < binarray.length * 4; i += 3) {
    var triplet = (((binarray[i >> 2] >> 8 * (i % 4)) & 0xFF) << 16) |
      (((binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4)) & 0xFF) << 8) |
      ((binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4)) & 0xFF);
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;
      else str += tab.charAt((triplet >> 6 * (3 - j)) & 0x3F);
    }
  }
  return str;
}

export default http;